import { render, staticRenderFns } from "./sendpicmatter.vue?vue&type=template&id=78b39cb7&scoped=true&"
import script from "./sendpicmatter.vue?vue&type=script&lang=js&"
export * from "./sendpicmatter.vue?vue&type=script&lang=js&"
import style0 from "./sendpicmatter.vue?vue&type=style&index=0&id=78b39cb7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b39cb7",
  null
  
)

export default component.exports